/**
 * iter291 — Hook para o contador do menu Relatório de Turno.
 * Faz polling a cada 60s + refresca ao mudar de secção.
 */
import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const useRelatorioBadge = () => {
  const [badge, setBadge] = useState({ count: 0, urgentes_por_ler: 0, pendentes_arrastados: 0 });

  const refetch = useCallback(async () => {
    try {
      const secao = localStorage.getItem('rt_secao') || '';
      const params = {};
      if (secao) params.secao = secao;
      const r = await axios.get(`${API}/api/relatorio-turno/badge-count`, {
        params,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setBadge(r.data || { count: 0 });
    } catch { /* silencioso — não bloqueia UI */ }
  }, []);

  useEffect(() => {
    refetch();
    const t = setInterval(refetch, 60000); // 60s polling
    // Refresh quando muda secção no localStorage (evento custom)
    const onStorage = (e) => {
      if (e.key === 'rt_secao') refetch();
    };
    window.addEventListener('storage', onStorage);
    return () => { clearInterval(t); window.removeEventListener('storage', onStorage); };
  }, [refetch]);

  return { badge, refetch };
};
